import React, { useState, useEffect } from 'react';
import { useRouteMatch, useHistory } from 'react-router-dom';
import classNames from 'classnames';
import { connectToStore } from '../../../store';
import Button from '../../../shared/button/Button';
import Toolbar from '../../../layout/Toolbar';
import { PlusIcon, TableIcon, RefreshIcon } from '../../../shared/icons';
import Table from '../../../shared/table/Table';
import { AgGridColumn } from 'ag-grid-react';
import styles from './ItemsTab.module.scss';

const ID_FIELD_KEY = `content_item_id`;

function navigateToItem(history, url, evt) {
	history.push(`${url}/items/${evt.data[ID_FIELD_KEY]}`);
}

function DataView({ loading, success, errorMessage, actions, rowData, tableState, setTableCtrl, navigateToItemBound }) {
	if (!loading && !success) {
		return (
			<div className={styles.errorView}>
				<span>Error: {errorMessage || `An unknown error ocurred`}</span>
			</div>
		);
	}

	return (
		<Table
			loading={loading}
			rowData={rowData}
			tableState={tableState}
			onStateChange={tableState => actions.contentItems.updateTableState(tableState)}
			onTableReady={tableCtrl => setTableCtrl(tableCtrl)}
		>
			<AgGridColumn type="id" field={ID_FIELD_KEY} onCellDoubleClicked={navigateToItemBound}></AgGridColumn>
			<AgGridColumn
				type="navigation"
				headerName="Title"
				field="title"
				tooltipField="title"
				minWidth={250}
				flex={1}
				onCellDoubleClicked={navigateToItemBound}
			></AgGridColumn>
			<AgGridColumn headerName="Type" field="content_type" width={110}></AgGridColumn>
			<AgGridColumn
				headerName="Status"
				field="status"
				width={120}
				valueFormatter={data => data.valueFormatted || data.value || `PUBLISHED`}
			></AgGridColumn>
			<AgGridColumn headerName="Themes" field="themes" width={200}></AgGridColumn>
			<AgGridColumn headerName="Tags" field="tags" width={250}></AgGridColumn>
			<AgGridColumn headerName="Author" field="author" width={200} tooltipField="author"></AgGridColumn>
			<AgGridColumn type="datetime" headerName="Created" field="created" sort="desc"></AgGridColumn>
		</Table>
	);
}

function ItemsTab({ state, actions, className }) {
	const { tableState, loading, success, errorMessage, rowData } = state.contentItems;
	const history = useHistory();
	const [tableCtrl, setTableCtrl] = useState(undefined);
	const { url } = useRouteMatch();
	const navigateToItemBound = navigateToItem.bind(undefined, history, url);
	const cls = classNames({
		[styles.itemsTab]: true,
		[className]: !!className,
	});
	useEffect(() => actions.contentItems.loadData(), [actions.contentItems]);

	return (
		<div className={cls}>
			<Toolbar>
				<Button to={`${url}/items/new`}>
					<PlusIcon />
					<span>Add Content</span>
				</Button>
				<Button onClick={() => actions.contentItems.loadData()} disabled={loading}>
					<RefreshIcon />
					<span>Refresh</span>
				</Button>
				<Button onClick={() => tableCtrl && tableCtrl.reset()} disabled={loading || !success}>
					<TableIcon />
					<span>Reset Table</span>
				</Button>
			</Toolbar>
			<DataView
				loading={loading}
				success={success}
				errorMessage={errorMessage}
				actions={actions}
				rowData={rowData}
				tableState={tableState}
				setTableCtrl={setTableCtrl}
				navigateToItemBound={navigateToItemBound}
			/>
		</div>
	);
}

export default connectToStore(ItemsTab);
